//@flow
import * as React from "react";
import "./dimmer.scss";

const Circle = (props: any) => (
  <div className="dimmer-white-gray-circle" style={{ width: props.size, height: props.size }}>
    {" "}
  </div>
);

export default Circle;
